import axios, { AxiosHeaderValue } from "axios";
import { ReactElement, useEffect, useState } from "react";
import Canvas from "../components/Canvas"
import { Button, Col, Form, FormControlProps, FormLabel, FormSelect, Row } from "react-bootstrap";
import ClusterModel from "../model/ClusterModel";
import BeaconModel from "../model/BeaconModel";
import Select, { GroupBase, OptionsOrGroups, SingleValue } from "react-select"
import beaconResultType from "../model/beaconResultType";
import React from "react";
import Header from "../components/Header";
import cluster from "cluster";
import ReactLoading from "react-loading";
import Loading from "../components/Loading";
import positionResultType from "../model/positionResultType";
import PositionLogLoading from "../components/PositionLogLoading";

const LogTrack = () => {
  const [apiKey, setApikey] = useState<string>("");
  const [detected_gt, setDetcted_gt] = useState<string>("");
  const [detected_lt, setDetcted_lt] = useState<string>("");
  

  //const [per_page, setPer_Page] = useState<string>("1000");
  //const [device_id, setDeviceId] = useState<string>("");
  const [clusterNo, setClusterNo] = useState<string>("");
  const [cluster_id, setCluster_id] = useState<string>("");
  const [clusterResult, setClusterResult] = useState<ClusterModel[]>([]);
  const clusterResults: ClusterModel[] = [];
  const DEVICEID_PLACEFOLDER: string  = "デバイスIDを選択して下さい";
  const CLUSTER_PLACEFORDER: string = "クラスタを選択して下さい";

  const [device_id, setDevice_Id] = useState<string>("");
  const [isManualInput, setIsManualInput] = useState(false); // false: select, true: text
  let loadingFlg: boolean = false;
  let positionLogloadingFlg: boolean = false;



  const [beaconResult, setBeaconResult] = useState<BeaconModel[]>([]);
  const beaconResults: BeaconModel[] = [];
  const [beaconLogResult, setResult] = useState<beaconResultType[]>([]);
  const beaconLogResults: beaconResultType[] = [];
  const checkBeaconLogResults: beaconResultType[] = [];

  const [positionLogResult, setpositionLogResult] = useState<positionResultType[]>([]);
  const positionLogResults: positionResultType[] = [];
  const [mounted, setMounted] = useState<string>("beacon");
  const [beacon_id, setBeaconId] = useState<string>("");
  const [period, setPeriod] = useState<string>("1")
  const [outDrawArea, setOutDrawArea] = useState<boolean>(false)


  const [beaconLogByIdResult, setbeaconLogByIdResult] = useState<beaconResultType[]>([]);
  const beaconLogByIdResults: beaconResultType[] = [];

  const [dispCanvas, setDispCanvas] = useState<boolean>(false);
  const [sDispLoading, setDispLoading] = useState(false);
  const [sIsLoading, setIsLoading] = useState(false);
  const [sIsPotisionLogLoading, setIsPotisionLogLoading] = useState(false);
  let dispLoading = false;
  let childRef = React.createRef()

  let clusterApiUrl = "https://api.bc-loco.jp/api/clusters"
  let beaconApiUrl = "https://api.bc-loco.jp/api/beacons"
  let beaconLogApiUrl = "https://api.bc-loco.jp/api/beacon_logs"
  let positionLogApiUrl = "https://api.bc-loco.jp/api/position_logs"

  const checkLocoEnv = () => {
    if (localStorage.getItem("locoEnv") === "prod") {
      clusterApiUrl = "https://api.bc-loco.jp/api/clusters"
      beaconApiUrl = "https://api.bc-loco.jp/api/beacons"
      beaconLogApiUrl = "https://api.bc-loco.jp/api/beacon_logs"
      positionLogApiUrl = "https://api.bc-loco.jp/api/position_logs"
    } else {
      clusterApiUrl = "http://stg.api.bc-loco.jp/api/clusters"
      beaconApiUrl = "http://stg.api.bc-loco.jp/api/beacons"
      beaconLogApiUrl = "http://stg.api.bc-loco.jp/api/beacon_logs"
      positionLogApiUrl = "http://stg.api.bc-loco.jp/api/position_logs"
    }
  }
  const getCluster = async(e: any) => {
      e.preventDefault();
      saveApikey();
      checkLocoEnv();
      await axios.get(clusterApiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
          ...({per_page: 1000})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        console.log(items)

        clusterResult.length = 0
        items.data.forEach((value: ClusterModel) => {
          clusterResults.push(value)
        })

        setClusterResult(clusterResults)

        const selectCluster = document.getElementById("cluster") as HTMLSelectElement;

        //Cluster一覧を全て消去
        let maxOptionLength = selectCluster.options.length;
        for ( let idx = maxOptionLength ; idx > 0 ; idx-- ) {
          console.log("maxoption:" + maxOptionLength)
          selectCluster.options.remove(idx)
        }

        //Clusterを設定
        clusterResults.forEach((value: ClusterModel, index: number) => {

          let insertClusterNameflg: Boolean = true;
          for ( let idx = 0 ; idx < selectCluster.options.length ; idx++ ) {
              if (selectCluster.options[idx].textContent == value.name) {
                insertClusterNameflg = false;
              }
          }

          if (insertClusterNameflg) {
            console.log(value.name)
            const option1 = document.createElement("option");
            option1.value = index.toString();
            option1.textContent = value.name;
            selectCluster?.appendChild(option1)
          }
        })
        
        getBeacons();
        
      })
      .catch(err => 
        alert("エラーが発生しました。" + err)
      )
  }

  const getBeacons = async() => {
      //e.preventDefault();
      checkLocoEnv();
      await axios.get(beaconApiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
          ...({per_page: 1000})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        console.log(items)

        items.data.forEach((value: BeaconModel) => {
          beaconResults.push(value)
        })

        setBeaconResult(beaconResults)
        
      })
      .catch(err => 
        alert("エラーが発生しました。" + err)
      )
  }

  const getBeaconLog = async(e: React.FormEvent<HTMLFormElement>, pageNo: number, deviceIdClear: boolean) => {
    e.preventDefault();
    checkLocoEnv();
    if (!loadingFlg) {
      console.log("setisloading")
      setIsLoading(true);
      loadingFlg = true;
    } 

    if (clusterNo == "" || clusterNo == CLUSTER_PLACEFORDER) {
      alert("クラスタが選択されていません。")
      setIsLoading(false);
      return
    } else if (detected_gt == "") {
      alert("開始時刻が入力されていません。")
      setIsLoading(false);
      return
    } else if (detected_lt == "") {
      alert("終了時刻が入力されていません。")
      setIsLoading(false);
      return
    } else if (new Date(detected_gt).getTime() >= new Date(detected_lt).getTime() ) {
      alert("開始時刻が終了時刻より新しい日付または同日同時刻が入力されています。")
      setIsLoading(false);
      return
    } 
    await axios.get(beaconLogApiUrl,
    {
      headers: {
          "Authorization": apiKey,
          "Content-Type": "application/json"
      },
      params: {
          ...({per_page: 1000}),
          ...(pageNo ? {page: pageNo} : {}),
          ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
          ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {})
      }
    })
    .then(async res => {
      console.log(res);
      if(res.data.code === 400) {
        alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
        return
      } else if(res.data.code === 401) {
        alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
        return
      }
      const items = JSON.parse(JSON.stringify(res.data.payload))
        
      if (items.total > 0) {
        if (items.total < 100001) {
          checkBeaconLogResults.length = 0
          items.data.forEach((value: beaconResultType, index: number) => {
            checkBeaconLogResults.push(value)
            checkBeaconLogResults[index].no = items.from;
            beaconLogResults.push(value)
            beaconLogResults[index].no = items.from;
            items.from++;
          })
          //setResult(beaconLogResults)
        } else {
          setIsLoading(false);
          alert("100000件を超えるデータは使用できません、日付範囲を調整して下さい " + "総件数:" + items.total + "件" )
          return
        }
        
      } else {
        setIsLoading(false);
        alert("対象の時間内にビーコンログが存在しませんでした。")
        return
      }
      
      if (deviceIdClear) {
        clearSelectDeviceID();
      }

      if (items.last_page != items.current_page) {
        if (items.last_page > 0) {
          await setDeviceIdForBeaconLogs(false);
        } else {
          await setDeviceIdForBeaconLogs(true);
        }
      } else {
        await setDeviceIdForBeaconLogs(true);
      }

      if (items.last_page != items.current_page) {
        if (items.last_page > 0) {
          getBeaconLog(e, items.current_page + 1, false);
        }
      } else {
        setIsLoading(false);
      }
    })
    .catch(err => 
      alert("エラーが発生しました。" + err)
    )
  }

  const getPostionLog = async(e: React.FormEvent<HTMLFormElement>, device_id: string, pageNo: number) => {
    e.preventDefault();
    checkLocoEnv();
    console.log("getPostionLog")
    
    if (detected_gt == "") {
      alert("開始時刻が入力されていません。")
      return
    } else if (detected_lt == "") {
      alert("終了時刻が入力されていません。")
      return
    } else if (new Date(detected_gt).getTime() >= new Date(detected_lt).getTime() ) {
      alert("開始時刻が終了時刻より新しい日付または同日同時刻が入力されています。")
      return
    } else if (mounted === "beacon" && (device_id == "" || device_id == DEVICEID_PLACEFOLDER)) {
      alert("デバイスIDが選択されていません。")
      return
    } else if (mounted === "device" && (beacon_id == "")) {
      alert("BeaconIDが入力されていません。")
      return
    } else if (Number(period) > 60 || Number(period) < 1) {
      alert("集計期間は1秒から60秒の範囲で入力してください。")
      return
    }
    if (!positionLogloadingFlg) {
      console.log("setIsPotisionLogLoading")
      setIsPotisionLogLoading(true);
      positionLogloadingFlg = true;
    } 

    //positionLogResults.length = 0;
    await axios.get(positionLogApiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
            ...({per_page: 1000}),
            ...(pageNo ? {page: pageNo} : {}),
            ...(device_id ? {device_id: device_id} : {}),
            ...(mounted ? {mounted: mounted} : {}),
            ...(beacon_id ? {beacon_id: beacon_id} : {}),
            ...(cluster_id ? {cluster_id: cluster_id} : {}),
            ...(period ? {period: period} : {}),
            ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
            ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          setIsPotisionLogLoading(false)
          return
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          setIsPotisionLogLoading(false)
          return
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 0) {
          items.data.forEach((value: positionResultType, index: number) => {
            positionLogResults.push(value)
            positionLogResults[index].no = items.from;
            items.from++;
          })
  
          setpositionLogResult(positionLogResults)
        } else {
          setIsPotisionLogLoading(false)
          alert("対象の時間内にポジションログが存在しませんでした。")
          return
        }
  
        if (items.last_page != items.current_page) {
          if (items.last_page > 0) {
            getPostionLog(e,device_id,items.current_page + 1);
          }
        } else {
          setIsPotisionLogLoading(false)
          setDispCanvas(true);
        }
      })
      .catch(err => 
        alert("エラーが発生しました。" + err)
      )


  }


  const getBeaconLogById = async(e: React.FormEvent<HTMLFormElement>, device_id: string, pageNo: number) => {
    e.preventDefault();
    checkLocoEnv();
    console.log("getBeaconLogById")
    if (detected_gt == "") {
      alert("開始時刻が入力されていません。")
      return
    } else if (detected_lt == "") {
      alert("終了時刻が入力されていません。")
      return
    } else if (new Date(detected_gt).getTime() >= new Date(detected_lt).getTime() ) {
      alert("開始時刻が終了時刻より新しい日付または同日同時刻が入力されています。")
      return
    } else if (device_id == "" || device_id == DEVICEID_PLACEFOLDER) {
      alert("デバイスIDが選択されていません。")
      return
    }
    beaconLogResults.length = 0;
    await axios.get(beaconLogApiUrl,
    {
      headers: {
          "Authorization": apiKey,
          "Content-Type": "application/json"
      },
      params: {
          ...({per_page: 1000}),
          ...(pageNo ? {page: pageNo} : {}),
          ...(device_id ? {device_id: [device_id]} : {}),
          ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
          ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
          ...({sort: "asc"})
      }
    })
    .then(async res => {
      console.log(res);
      if(res.data.code === 400) {
        alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
        return
      } else if(res.data.code === 401) {
        alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
        return
      }
      const items = JSON.parse(JSON.stringify(res.data.payload))
      if (items.total > 0) {
        items.data.forEach((value: beaconResultType, index: number) => {
          beaconLogByIdResults.push(value)
          beaconLogByIdResults[index].no = items.from;
          items.from++;
        })

        setbeaconLogByIdResult(beaconLogByIdResults)
      } else {
        alert("対象の時間内にビーコンログが存在しませんでした。")
        return
      }

      if (items.last_page != items.current_page) {
        if (items.last_page > 0) {
          getBeaconLogById(e,device_id,items.current_page + 1);
        }
      } else {
        setDispCanvas(true);
      }
    })
    .catch(err => 
      alert("エラーが発生しました。" + err)
    )
  }

  const setDeviceIdForBeaconLogs = async(lastBeaconlogsFlg: boolean) => {
    const selectDeviceID = document.getElementById("deviceid") as HTMLSelectElement;
    console.log("beaconLogResults:" + beaconLogResults.length)
    checkBeaconLogResults.forEach(async (value: beaconResultType, index: number) => {
      let insertDeviceidflg: Boolean = true;
      for ( let idx = 0 ; idx < selectDeviceID.options.length ; idx++ ) {
          if (selectDeviceID.options[idx].value == value.device_id) {
            insertDeviceidflg = false;
          }
      }

      //選択したクラスタに存在するビーコンが対象のIDのログに存在するか
      
      if (insertDeviceidflg) {
        
        if (checkDeviceidinCluster(value.device_id)) {
          const option1 = document.createElement("option");
          option1.value = value.device_id;
          option1.textContent = value.device_id;
          selectDeviceID?.appendChild(option1)
        }
        
        /*
        const option1 = document.createElement("option");
          option1.value = value.device_id;
          option1.textContent = value.device_id;
          selectDeviceID?.appendChild(option1)
          */
        
      }
      
    })

    if (lastBeaconlogsFlg) {
      if (selectDeviceID.childElementCount < 2 ) {
        alert("対象のクラスタに対応するデバイスIDが存在しませんでした")
      }
    }
    
    console.log("setDeviceIdForBeaconLogs End")
  }

  const checkDeviceidinCluster = (devId: string) =>  {
    
      let ret = false;
      
      let beaconlogFilterDeviceid = checkBeaconLogResults.filter(function(value) {
        return value.device_id === devId; 
      });

      let beaconIds = beaconlogFilterDeviceid.filter((e, index, self) => {
        return self.findIndex((el) => el.beacon_id === e.beacon_id) === index;
      });
    
      
      let clusterbeacons = clusterResult[Number(clusterNo)].beacons;
      for (const beacon of beaconIds) {
        if (clusterbeacons.some(el => el.id === beacon.beacon_id)) {
          ret = true;
          break;
        }
      }
      
    
      return ret;
  }

  const changePeriod = (value: string) => {
    setPeriod(value);
    setDispCanvas(false);
  }


  const selectCluster = (clusteridx: string) => {
    setClusterNo(clusteridx);
    setCluster_id(clusterResult[Number(clusteridx)].id)
    setDispCanvas(false);
    clearSelectDeviceID();
  }

  const changeDetected_gt = (value: string) => {
    setDispCanvas(false);
    setDetcted_gt("");
    clearSelectDeviceID();
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00"
    }
    setDetcted_gt(value);
  } 

  const changeDetected_lt = (value: string) => {
    setDispCanvas(false);
    setDetcted_lt("");
    clearSelectDeviceID();
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00"
    }
    setDetcted_lt(value);
  } 


  const selectDeviceID = (deviceid: string) => {
    setDispCanvas(false);
    setDevice_Id(deviceid);
  }

  const clearSelectDeviceID = () => {
    if (mounted === "beacon") {
      const selectDeviceID = document.getElementById("deviceid") as HTMLSelectElement;
      if (!isManualInput) {
        let maxOptionLength = selectDeviceID.options.length;
        for ( let idx = maxOptionLength ; idx > 0 ; idx-- ) {
          console.log("maxoption:" + maxOptionLength)
          selectDeviceID.options.remove(idx)
        }
      } else {
        const inputDeviceID = document.getElementById("deviceid") as HTMLInputElement;
        inputDeviceID.value = "";
      }
    }
  }

  const changeApiKey = (apikey: string) => {
    setApikey(apikey)
    setDispCanvas(false);
    setDetcted_gt("");
    setDetcted_lt("");
    clearSelectDeviceID();
    clearSelectCluster();
  }

  const saveApikey = () => {
    localStorage.setItem("locoTerminalApikey", apiKey ? apiKey : "" );
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoTerminalApikey")
    if (locoApikey != null) {
      setApikey(locoApikey ? locoApikey : "");
    }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoTerminalSecretArray")
    if (secretJson != null) {
      const secret = JSON.parse(secretJson as string)

      const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
      const option1 = document.createElement("option");
      option1.value = "";
      option1.textContent = "APIKeyを選択して下さい";
      selectApikey?.appendChild(option1)

      secret.forEach((element: { apikey: string; name: string | null; }) => {
          const option1 = document.createElement("option");
          option1.value = element.apikey;
          option1.textContent = element.name;
          selectApikey?.appendChild(option1)
      })        
    }
  }

  const clearSelectCluster = () => {
    const selectCluster = document.getElementById("cluster") as HTMLSelectElement;
    let maxOptionLength = selectCluster.options.length;
    for ( let idx = maxOptionLength ; idx > 0 ; idx-- ) {
      console.log("maxoption:" + maxOptionLength)
      selectCluster.options.remove(idx)
    } 
  }

  const drawingOutSideArea = (value : boolean) => {
    setOutDrawArea(value)
  }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoTerminalSecretArray")
    if (secretJson != null) {
      setSelectApikey()
    }
    loadApikey();
    
  },[])

  return (
      <div>
      <Header current_page="Tracker"/>
      <div className="card">
        <Form className="font-weight-bold" onSubmit={(e) => getCluster(e)}>
          <Row className="mx-3">
            <Form.Label className="w-20 ml-3">API KEY</Form.Label>
          </Row>
          <Row className="mx-3">
            <Form.Group as={Col}>
              <Form.Control as="select" id="apikey" className="w-20" value={apiKey as string} onChange={(e) => changeApiKey(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Group as={Button} type="submit">クラスタを取得</Form.Group>
            </Form.Group>
          </Row>
        </Form>

        <Row className="mx-3">
          <Form.Group as={Col}>
            <Form.Label className="font-weight-bold w-20" >クラスタ</Form.Label>
            <Form.Control as="select"  className="w-20" id="cluster" onChange={e => selectCluster(e.target.value)}>
              <option>{CLUSTER_PLACEFORDER}</option>
            </Form.Control>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Mounted （Beacon固定またはDevice固定を指定）</Form.Label>
              <Form.Control as="select" className="w-27" value={mounted as string} onChange={e => setMounted(e.target.value)} >
                <option value="beacon">Beacon</option>
                <option value="device">Device</option>
              </Form.Control>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Period （集計期間：デフォルト1秒　最大60秒）</Form.Label>
            <Form.Control type="text" name="period" className="w-20" value={period as string}  placeholder="集計期間を指定" onChange={(e) => changePeriod(e.target.value)} />
          </Form.Group>
        </Row>
        {
        (() => {
          if (mounted === "beacon") {
            return (
              <div>
              <Form className="font-weight-bold" onSubmit={(e) => getBeaconLog(e, 1, true)}>
                <Row className="mx-3">
                  <Form.Group as={Col}>
                    <Form.Label className="w-20">開始時刻</Form.Label>
                    <Form.Control type="datetime-local" step="1" name="from" className="w-20" value={detected_gt as string} placeholder="開始時刻を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetected_gt(e.target.value)} />
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label className="w-20">終了時刻</Form.Label>
                    <Form.Control type="datetime-local" step="1" className="w-20" value={detected_lt as string} placeholder="終了時刻を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetected_lt(e.target.value)} />
                  </Form.Group>
                </Row>
                {!isManualInput && (
                  <Row className="mx-3">
                    <Form.Group as={Col}>
                      <Form.Group as={Button} type="submit" className="mt-3 mb-2">開始時刻から終了時刻までのデバイスIDを取得</Form.Group>
                    </Form.Group>
                  </Row>
                )}
              </Form>
              <Form className="font-weight-bold">
                <Row className="mx-3">
                  <Form.Group as={Col}>
                    <Form.Label className="w-20" >デバイスID</Form.Label>
                    <div style={{ marginBottom: '0.5em' }}>
                      <Form.Check
                        type="checkbox"
                        label="直接入力する"
                        checked={isManualInput}
                        onChange={() => setIsManualInput((prev) => !prev)}
                      />
                    </div>
                    {isManualInput ? (
                      <Form.Control
                        type="text"
                        className="w-20"
                        id="deviceid"
                        value={device_id}
                        onChange={e => setDevice_Id(e.target.value)}
                        placeholder="デバイスIDを入力"
                      />
                    ) : (
                      <Form.Control
                        as="select"
                        className="w-20"
                        id="deviceid"
                        onChange={e => selectDeviceID(e.target.value)}
                      >
                        <option>{DEVICEID_PLACEFOLDER}</option>
                      </Form.Control>
                    )}
                  </Form.Group>
                </Row>
              </Form>
              </div>
            )
          } else {
            return (
              <div>
              <Form className="font-weight-bold" onSubmit={(e) => getBeaconLog(e, 1, true)}>
                <Row className="mx-3">
                  <Form.Group as={Col}>
                    <Form.Label className="w-20">開始時刻</Form.Label>
                    <Form.Control type="datetime-local" step="1" name="from" className="w-20" value={detected_gt as string} placeholder="開始時刻を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetected_gt(e.target.value)} />
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label className="w-20">終了時刻</Form.Label>
                    <Form.Control type="datetime-local" step="1" className="w-20" value={detected_lt as string} placeholder="終了時刻を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetected_lt(e.target.value)} />
                  </Form.Group>
                </Row>
                <Row className="mx-3">
                  <Form.Group as={Col}>
                    <Form.Label className="w-20">BeaconID</Form.Label>
                    <Form.Control type="text" name="beacon_id" className="w-20" value={beacon_id as string}  placeholder="BeaconIDを指定" onChange={(e) => setBeaconId(e.target.value)} />
                  </Form.Group>
                </Row>
              </Form>
              </div>
            )
          }
        })()  
      }
      <Form className="font-weight-bold" onSubmit={(e) => getPostionLog(e, device_id, 1)}>
        <div className="text-center">
          <Form.Group as={Button} type="submit" className="w-20 mt-3 mb-2">マップを表示</Form.Group>
        </div>
        <div className="text-center">
          <Form.Check label="マップ画像外への移動も表示する" name="check" onChange={(e) => drawingOutSideArea(e.target.checked)}/>
        </div>
        
      </Form>
      {
        (() => {
          if (dispCanvas == true) {
            return <div>PositionLogsCount: {positionLogResult.length}</div>
          }
        })()  
      }
      
      </div> 
      {
        
        (() => {
          if (sIsLoading) {
              return <Loading disp={sIsLoading}/>
          }
        })()  
        
      }
       {
        
        (() => {
          if (sIsPotisionLogLoading) {
              return <PositionLogLoading disp={sIsPotisionLogLoading}/>
          }
        })()  
        
      }

      {
        (() => {
          if (dispCanvas == true) {
            return <Canvas clusterData={clusterResult} beaconData={beaconResult} clusterNo={clusterNo} positionLogs={positionLogResult} startDetectTime= {detected_gt} endDetectTime= {detected_lt} mounted={mounted} outArea={outDrawArea}/> 
          } 
        })()       
          //dispCanvas ? <Canvas clusterData={clusterResult} beaconData={beaconResult} clusterNo={clusterNo} beaconlogs={beaconLogByIdResult} startDetectTime= {detected_gt} endDetectTime= {detected_lt}/> : null
      }
    </div>
      
      
    
  );
}

export default LogTrack